import { render, staticRenderFns } from "./Bad.vue?vue&type=template&id=4b258f2a&"
import script from "./Bad.vue?vue&type=script&lang=js&"
export * from "./Bad.vue?vue&type=script&lang=js&"
import style0 from "./Bad.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports